"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPreviousMediatorDetailsDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
class OpportunityPreviousMediatorDetailsDto {
}
exports.OpportunityPreviousMediatorDetailsDto = OpportunityPreviousMediatorDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Company Id of the previous mediator",
        example: 123,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Company Id is required" }),
    (0, class_validator_1.IsInt)({ message: "Company Id must be a valid integer" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPreviousMediatorDetailsDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Location Id of the previous mediator",
        example: 456,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Location Id is required" }),
    (0, class_validator_1.IsInt)({ message: "Location Id must be a valid integer" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPreviousMediatorDetailsDto.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Branch Id of the previous mediator",
        example: 789,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Branch Id is required" }),
    (0, class_validator_1.IsInt)({ message: "Branch Id must be a valid integer" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPreviousMediatorDetailsDto.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Mediator Type Id of the previous mediator",
        example: 101,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Mediator Type Id is required" }),
    (0, class_validator_1.IsInt)({ message: "Mediator Type Id must be a valid integer" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPreviousMediatorDetailsDto.prototype, "mediatorTypeId", void 0);
